export const formatPhoneFR = (value = "") => {
  const digits = String(value).replace(/\D/g, "");
  return digits.replace(/(\d{2})(?=\d)/g, "$1 ").trim();
};
